import * as React from "react";
import { FormInput } from "./FormInput";
import { Input } from "./Input";
export function CustomFieldInput(props) {
    // overrides the children props only
    props = Object.assign(Object.assign({}, props.group.computedChildrenProps), props);
    var field = props.field, inputType = field.inputType, fieldKey = field.name;
    fieldKey = fieldKey[0].toLowerCase() + fieldKey.substr(1);
    var tProps = Object.assign({ type: inputType, groupKey: fieldKey, labelText: field.labelText, name: (props.namePrefix || '') + field.name, placeholder: field.placeholder, required: field.required }, props);
    if (inputType === "select") {
        tProps.children = field.options.map(e => React.createElement("option", { key: e.id, value: e.value }, e.text));
    }
    else if (inputType === "radio") {
        tProps.children = field.options;
    }
    if (props.inputOnly) {
        return React.createElement(Input, Object.assign({}, tProps));
    }
    return React.createElement(FormInput, Object.assign({}, tProps));
}
//# sourceMappingURL=CustomFieldInput.js.map